export enum GridFilterName {
  Bool = 'grid-bools',
  Date = 'grid-dates',
  Number = 'grid-numbers',
  Search = 'grid-search',
  Select = 'grid-selects',
  String = 'grid-strings'
}
